// @flow

import React, { Component } from 'react'
import { containerIds } from 'redux/modules/ui'
import { wwwUrl, accountLoginUrl } from 'frontend_core/dist/helpers/url'
import { type Room as RoomType } from 'types/room'

export type RoomSliderUseCaseType = {
  initialize: Function,
  openFavoriteList: Function,
  addFavorite: Function,
}

export default (WrappedComponent: any) =>
  class RoomSliderUseCase extends Component<*> {
    /**
     * 初期処理
     */
    initialize = (roomList: Array<RoomType>) => {
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {})

      actions.importFromRoomList(roomList)
    }

    /**
     * お気に入りリスト表示
     */
    openFavoriteList = (targetRoom: RoomType) => {
      const { currentUser } = this.props
      if (!currentUser) {
        // ログインしてなければログイン画面へリダイレクト
        window.location.href = accountLoginUrl(this.props.config)
      } else {
        const { actions } = this.props
        actions.setUIState(containerIds.ROOM, {
          room: targetRoom,
          isOpenFavoriteSelectModal: true,
        })
      }
    }

    /**
     * お気に入りに追加
     */
    addFavorite = (
      e: Event,
      room: RoomType,
      showingFavoriteListTooltipList?: Array,
    ) => {
      e.preventDefault()
      const { localRooms, currentUser } = this.props
      const targetRoom = localRooms.roomMap[room.id]
      if (!currentUser) {
        window.location = accountLoginUrl(this.props.config)
      } else if (targetRoom && targetRoom.isFavorite) {
        // すでにお気に入りならお気に入りリストを開く
        this.openFavoriteList(room)
      } else {
        const { actions } = this.props
        actions.addFavorite({
          userId: currentUser.id,
          roomId: room.id,
          showingFavoriteListTooltipList,
        })
      }
    }

    render() {
      return <WrappedComponent {...this.props} usecase={this} />
    }
  }



// WEBPACK FOOTER //
// ./src/containers/organisms/room/RoomCardSlider/usecase.js